import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  CircularProgress,
  Typography,
  useTheme,
} from '@mui/material';
import { api } from '../helpers/apiRequest';
import { toast } from 'react-toastify';
import colors from '../theme/Colors';

const UpdateRateForm = ({ open, handleClose, selectedRateId, onSuccess,selectedRate }) => {
  const [price, setPrice] = useState(selectedRate?.price);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const handleSubmit = async () => {
    if (!price || isNaN(price)) {
      alert('Please enter a valid price.');
      return;
    }

    setLoading(true);

    try {
      const user = JSON.parse(localStorage.getItem('user')); // Assuming user is stored in localStorage
      const updatedBy = user?.id || '';

     const response = await api.put(
        `inventory/rate/${selectedRateId._id}`,
        {
          price: Number(price),
          updated_by: updatedBy,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      // alert('Rate updated successfully!');
      toast.success('Rate updated successfully!');
      // onSuccess(); // Callback to refresh rates or perform additional actions
      handleClose(); // Close the dialog
    } catch (error) {
      console.error('Error updating rate:', error);
      // toast.error('Error updating rate:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: colors.primary,
          color: theme.palette.primary.contrastText,
          textAlign: 'center',
        }}
      >
        Update Rate
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          padding: theme.spacing(3),
          backgroundColor: theme.palette.background.default,
        }}
      >
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Typography variant="body1" color="textSecondary">
              Please enter the new price for the rate.
            </Typography>
            <TextField
              label="New Price"
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              fullWidth
              variant="outlined"
            />
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="black"
                style={{backgroundColor:colors.primary}}
                onClick={handleSubmit}
              >
                Update
              </Button>
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default UpdateRateForm;
